import { useCallback } from "react";
import { useDispatch, useStore } from "react-redux";
import { RootState, useAppSelector } from "src/store";
import { useApplicationsApi } from "../api";
import { resetError, resetList, setError, setFilter, setList, setLoading } from "../slices";

export const useApplicationsService = () => {
  const dispatch = useDispatch();
  const { getState } = useStore<RootState>();
  const { loading, filter, list, error } = useAppSelector((state) => state.applications);

  const api = useApplicationsApi();

  const getApplications = useCallback(async () => {
    const filter = getState().applications.filter;

    try {
      dispatch(resetError());
      dispatch(setLoading({ getList: true }));

      const response = await api.getAdminApplications({
        limit: filter.limit,
        offset: filter.offset,

        query: filter.query || undefined,
        sort: filter.sort,
        domain: filter.domain || undefined,
      });
      dispatch(setList(response.data));

      return response.data;
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ getList: false }));
    }
  }, []);

  const changeApplicationsFilter = useCallback((filter: Partial<RootState["applications"]["filter"]>) => {
    dispatch(setFilter(filter));
  }, []);

  const resetApplications = useCallback(() => {
    dispatch(resetList());
  }, []);

  return {
    loading,
    filter,
    list,
    error,
    getApplications,
    changeApplicationsFilter,
    resetApplications,
  };
};
